import { render, staticRenderFns } from "./WsSearchUsers.vue?vue&type=template&id=8673e1be"
import script from "./WsSearchUsers.vue?vue&type=script&lang=js"
export * from "./WsSearchUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports